module.exports = __webpack_public_path__ + "img/Compilation_Error_small.17ae9493.svg";